import NamedDto from 'modules/base/dto/NamedDto';

export default class PredictionTypeTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.project = null;
		/** @type {NamedDto} */
		this.sourceDeviceType = null;
		/** @type {NamedDto} */
		this.targetDeviceType = null;
	}

	/**
	 * @typedef {Object} _PredictionTypeTableDtoProps
	 * @property {NamedDto} project
	 * @property {NamedDto} sourceDeviceType
	 * @property {NamedDto} targetDeviceType
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PredictionTypeTableDtoProps} PredictionTypeTableDtoProps
	 */
	/**
	 * @param {PredictionTypeTableDtoProps} props
	 * @returns {PredictionTypeTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project != null ? new NamedDto().setup(props.project) : null;
		this.sourceDeviceType = props.sourceDeviceType != null ? new NamedDto().setup(props.sourceDeviceType) : null;
		this.targetDeviceType = props.targetDeviceType != null ? new NamedDto().setup(props.targetDeviceType) : null;
		return this;
	}
}
